<template>
  <div v-if="loading"
       class="circular-loader">
    <base-circular-loader color="primary"
                          size="medium" />
  </div>
  <div v-else>
    <div class="hint"
         :class="hintStyles">
      <icon-key width="50" height="60" />
      <div class="hint-text">
        {{ $t("websiteSettings.description") }}
        <br>
        <div class="link"
             @click="openContentFilter">
          {{ $t("websiteSettings.contentFilterRedirect") }}
        </div>
      </div>
    </div>
    <website-settings-list :urls="blockedUrls"
                           :url-settings="urlSettings"
                           :mode-id="modeId"
                           list-type="block"

                           @addUrlSetting="addUrlSetting"
                           @deleteUrlSetting="deleteUrlSetting" />
    <website-settings-list :urls="allowedUrls"
                           :url-settings="urlSettings"
                           :mode-id="modeId"
                           list-type="allow"

                           @addUrlSetting="addUrlSetting"
                           @deleteUrlSetting="deleteUrlSetting" />
  </div>
</template>

<script>
  import WebsiteSettingsList from '@/components/Child/ChildWebsiteSettings/WebsiteSettingsList'
  import errorNotification from '@/mixins/errorNotification.js'
  import analytics from '@/services/analytics.js'
  import urlsApi from '@/api/urlSetting.js'

  export default {
    mixins: [
      errorNotification
    ],

    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      }
    },

    components: {
      WebsiteSettingsList
    },

    data() {
      return {
        loading: true
      }
    },

    created() {
      analytics.sendEvent('SiteStgs_Sc')

      this.getUrlsSettings()
    },

    methods: {
      ...mapActions('children', {
        setUrlSettings: 'setUrlSettings'
      }),

      getUrlsSettings() {
        this.loading = true

        this.setUrlSettings({
          user_id: this.childId,
          mode_id: this.modeId
        })

        this.loading = false
      },

      addUrlSetting(setting) {
        let modeId = this.modeId
        let url = setting.url
        let mode = setting.mode

        urlsApi.create(modeId, url, mode)
          .then(() => {
            this.getUrlsSettings()
          })
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      deleteUrlSetting(id) {
        let modeId = this.modeId

        urlsApi.delete(modeId, id)
          .then(() => {
            this.getUrlsSettings()
          })
          .catch(() => {
            this.failedRequestNotification()
          })
      },

      openContentFilter() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.contentFilter',
            params: {
              modeId: this.modeId,
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('content', {
          modeId: this.modeId,
          childId: this.child.id
        })
      }
    },

    computed: {
      ...mapGetters('children', {
        getUrlSettings: 'getUrlSettings'
      }),

      urlSettings() {
        return this.getUrlSettings(this.childId)
      },

      blockedUrls() {
        return this.urlSettings.filter(url => url.action === 'block')
      },

      allowedUrls() {
        return this.urlSettings.filter(url => url.action === 'allow')
      },

      child() {
        return this.getChildById(this.childId)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      hintStyles() {
        return {
          'hint-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .circular-loader {
    display: flex;
    justify-content: center;
    padding: 50px 0;
  }

  .hint {
    display: flex;
    justify-content: space-between;
    margin: 0 0 30px 0;

    &-text {
      width: 380px;
      color: #3e3a3b;

      .link {
        font-size: 16px;
        color: map-get($colors, primary);
        cursor: pointer;
      }
    }
  }

  .hint-mobile {
    .hint-text {
      font-size: 16px;
      margin-left: 10px;
    }
  }
</style>
